/*
 * Potzillas — Souhlas s VOP v košíku → cart attributes
 * ----------------------------------------------------
 * Skript řeší dvě věci: DOKLADOVATELNOST a ŽIVÉ PŘEPNUTÍ znění na B2B.
 *
 * A) Dokladovatelnost
 *
 *  1) Tlačítko Pokladna — skryté inputy odejdou s formulářem samy, my jen
 *     těsně před odesláním přerazítkujeme čas, aby v objednávce byl okamžik
 *     kliknutí, ne okamžik vykreslení košíku (ten může být i pár dní starý,
 *     protože cart attributes v Shopify přežijí i vyprázdnění košíku).
 *
 *  2) Expresní tlačítka (Apple Pay / Google Pay / PayPal) formulář vůbec
 *     nesubmitují — jdou rovnou do checkoutu. Běží v uzavřeném shadow DOM,
 *     takže na ně nejde sáhnout, ale klik se díky retargetingu objeví na
 *     našem obalu .cart__dynamic-checkout-buttons. Tam ho odchytíme a
 *     atributy zapíšeme přes /cart/update.js s keepalive (request přežije
 *     i odnavigování).
 *
 * B) Živé přepnutí na B2B znění
 *
 *     Jakmile zákazník vyplní Název firmy / IČO / DIČ, nakupuje jako
 *     podnikatel a musí vidět Obchodní podmínky pro podnikatele. Liquid to
 *     umí až po uložení do cart attributes (tedy po překreslení košíku),
 *     takže okamžité přepnutí během psaní děláme tady.
 *
 *     KRITICKÉ: přepínají se ATOMICKY všechny tři vrstvy najednou —
 *     viditelná věta, skryté inputy i data atributy pro expresní tlačítka.
 *     Kdyby se rozešly, zobrazilo by se B2B znění a do objednávky by se
 *     zapsalo spotřebitelské; to je horší než featuru vůbec nemít. Proto se
 *     applyMode() volá i těsně před odesláním a před expresním zápisem —
 *     rozhoduje stav polí v okamžiku odchodu do pokladny.
 *
 *     Zákazník s tagem `b2b` má znění zamčené (snippet nevyrenderuje
 *     data-consent-switchable) — vyprázdněním polí se zpátky nedostane.
 *
 * Bez JS zůstává funkční cesta 1 (s časem vykreslení místo času kliknutí)
 * a B2B větev z Liquidu podle už uložených cart attributes.
 */
(function () {
  'use strict';

  if (window.__pzCartConsent) return;
  window.__pzCartConsent = true;

  var CART_FORMS = ['cart', 'CartDrawer-Form'];
  var COMPANY_SELECTOR =
    'input[name="attributes[firma]"], input[name="attributes[ico]"], input[name="attributes[dic]"]';

  function pad(n, width) {
    var s = String(Math.abs(n));
    while (s.length < (width || 2)) s = '0' + s;
    return s;
  }

  // ISO 8601 s lokálním offsetem, např. 2026-07-29T14:22:31+02:00
  function iso(date) {
    var off = -date.getTimezoneOffset();
    var sign = off >= 0 ? '+' : '-';
    return (
      date.getFullYear() +
      '-' + pad(date.getMonth() + 1) +
      '-' + pad(date.getDate()) +
      'T' + pad(date.getHours()) +
      ':' + pad(date.getMinutes()) +
      ':' + pad(date.getSeconds()) +
      sign + pad(Math.floor(Math.abs(off) / 60)) + ':' + pad(Math.abs(off) % 60)
    );
  }

  function consentEl() {
    return document.querySelector('[data-cart-consent]');
  }

  /* --- B) Přepnutí spotřebitel / podnikatel --- */

  // Firemní pole jsou i ve variantě „saved" (přihlášený s metafieldy), tam
  // jsou skrytá a předvyplněná — a to je správně: takový zákazník opravdu
  // nakupuje na firmu.
  function looksLikeCompany() {
    var inputs = document.querySelectorAll(COMPANY_SELECTOR);
    for (var i = 0; i < inputs.length; i++) {
      if (String(inputs[i].value || '').trim() !== '') return true;
    }
    return false;
  }

  function applyMode() {
    var el = consentEl();
    if (!el || !el.hasAttribute('data-consent-switchable')) return;

    var mode = looksLikeCompany() ? 'podnikatel' : 'spotrebitel';
    if (el.getAttribute('data-consent-rezim') === mode) return; // beze změny

    var prefix = mode === 'podnikatel' ? 'data-b2b-' : 'data-std-';
    var verze = el.getAttribute(prefix + 'verze') || '';
    var url = el.getAttribute(prefix + 'url') || '';
    var text = el.getAttribute(prefix + 'text') || '';
    var html = el.getAttribute(prefix + 'html') || '';

    // 1) viditelná věta
    var body = el.querySelector('[data-consent-body]');
    if (body && html) body.innerHTML = html;

    // 2) data atributy (čte je expresní cesta)
    el.setAttribute('data-consent-rezim', mode);
    el.setAttribute('data-consent-verze', verze);
    el.setAttribute('data-consent-url', url);
    el.setAttribute('data-consent-text', text);

    // 3) skryté inputy (odejdou s tlačítkem Pokladna)
    var map = { rezim: mode, verze: verze, url: url, text: text };
    Object.keys(map).forEach(function (key) {
      document.querySelectorAll('input[data-consent-field="' + key + '"]').forEach(function (input) {
        input.value = map[key];
      });
    });
  }

  var applyTimer = null;
  function applyModeSoon() {
    if (applyTimer) clearTimeout(applyTimer);
    applyTimer = setTimeout(applyMode, 150);
  }

  // Delegovaně na document — košík se překresluje (drawer i /cart), takže se
  // nechceme navazovat na konkrétní inputy a po každém renderu znovu.
  ['input', 'change'].forEach(function (type) {
    document.addEventListener(
      type,
      function (event) {
        var target = event.target;
        if (!target || typeof target.matches !== 'function') return;
        if (!target.matches(COMPANY_SELECTOR)) return;
        applyModeSoon();
      },
      true
    );
  });

  // Po překreslení košíku vyrenderuje správné znění Liquid z cart attributes;
  // tohle pokrývá mezistav, kdy uživatel psal a hodnoty se ještě neuložily.
  document.addEventListener('shopify:section:load', applyMode);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyMode);
  } else {
    applyMode();
  }

  /* --- A1) Pokladna: srovnej znění a přerazítkuj čas těsně před odesláním --- */
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.id || CART_FORMS.indexOf(form.id) === -1) return;

      if (applyTimer) clearTimeout(applyTimer);
      applyMode(); // rozhoduje stav polí v okamžiku odeslání

      var now = iso(new Date());
      document.querySelectorAll('input[data-consent-time]').forEach(function (input) {
        if (input.getAttribute('form') === form.id) input.value = now;
      });
    },
    true
  );

  /* --- A2) Expresní tlačítka: zapiš atributy rovnou, formulář se neodešle --- */
  var lastSync = 0;
  function syncFromExpress() {
    var el = consentEl();
    if (!el) return;
    var now = Date.now();
    if (now - lastSync < 1500) return; // pointerdown + click by jinak poslal dvakrát
    lastSync = now;

    if (applyTimer) clearTimeout(applyTimer);
    applyMode(); // i tady musí sedět znění se stavem polí

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          souhlas_op: 'ano',
          souhlas_op_cas: iso(new Date()),
          souhlas_op_rezim: el.getAttribute('data-consent-rezim') || '',
          souhlas_op_verze: el.getAttribute('data-consent-verze') || '',
          souhlas_op_url: el.getAttribute('data-consent-url') || '',
          souhlas_op_text: el.getAttribute('data-consent-text') || '',
        },
      }),
      keepalive: true,
    }).catch(function () {});
  }

  // Delegovaně na document — obal expresních tlačítek Shopify doplňuje
  // asynchronně a košík se překresluje, takže se nechceme navazovat znovu.
  ['pointerdown', 'click'].forEach(function (type) {
    document.addEventListener(
      type,
      function (event) {
        var target = event.target;
        if (!target || typeof target.closest !== 'function') return;
        if (!target.closest('.cart__dynamic-checkout-buttons')) return;
        syncFromExpress();
      },
      true
    );
  });
})();
